import { Fragment } from "react";
import { TitleHeader, CardReport } from "../../components/commons";
import lista_usuario from "../../assets/lista_usuario.png";
import file_excel from "../../assets/excel.png";
import { downloadExcelFile, downloadDetallado } from "../../api/participante";
import { DATE_LIKE_NAME } from "../../utils/functions";

function Reportes(props) {
  // ------------- Descarga supervisores -------------
  const downloadParticipante = async () => {
    const blob = await downloadExcelFile();

    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `participante-${DATE_LIKE_NAME}.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  const downloadParticipanteDetallado = async () => {
    const blob = await downloadDetallado();

    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `participante-detallado-${DATE_LIKE_NAME}.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  return (
    <Fragment>
      <TitleHeader title="Reportes" />
      <div className="flex gap-2">
        <CardReport
          onClick={downloadParticipante}
          desc="Descargar participantes"
          imgSrc={lista_usuario}
          imgAlt="imagen lista participantes"
        />
        <CardReport
          onClick={downloadParticipanteDetallado}
          desc="Descargar participantes detallado"
          imgSrc={file_excel}
          imgAlt="imagen lista participantes detallado"
        />
      </div>
    </Fragment>
  );
}

export default Reportes;
